export const DEFAULT_FILTER = 'default~eq~true';
